<div class="h-100 w-100" [ngClass]="{ 'agentic': isAgentic }">
  <div
    *ngIf="!isDataLoading && isTableDataReady"
    class="scollabelClass h-100 d-flex flex-column"
  >
    <div class="header-5 actions-wrapper-1 d-flex justify-content-between" >
      <div class="d-flex" [ngClass]="{'d-none': isAgentic}">
        <button
          class="dropdown-accello-primary position-relative d-flex mx-2 mx-1 "
          [disabled]="isDataLoading"
          [matMenuTriggerFor]="recMenu"
        >
          <span>Test Script Generator</span>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>

        <!-- <button
          *ngIf="!isAiRecorderEnabled"
          class="btn-transparent-outlined-white mx-2 rounded-100"
          (click)="openWebRecorder()"
        >
          Load Recorded Activities
        </button> -->

        <button
          class="btn-accello-secondary tc-mapping-btn mx-2"
          (click)="openMappingModal()"
        >
          <div class="d-flex">
            <span class="tc-mapping"> Test Case Mapping <strong
              *ngIf="this.meta?.script?.tcgTestCaseResultName"
              class="mapping-name-label"
              [matTooltip]="this.meta.script.tcgTestCaseResultName"
              matTooltipPosition="below"
              matTooltipClass="mapping-name-tooltip"
            > {{ (this.meta.script.tcgTestCaseResultName.length > 15 ? (this.meta.script.tcgTestCaseResultName | slice:0:15) + '…' : this.meta.script.tcgTestCaseResultName) }} </strong> </span>
          </div>
        </button>
      </div>
      <div class="d-flex drp-content">
        <div class="d-flex flex-grow-1" *ngIf="isAgentic">
          <div class="d-flex align-items-center">
            <span class="scr-name"> {{ meta?.script?.name }} </span>
          </div>

          <div class="version-tag d-flex align-items-center mx-3">
            <span> <span class="ligher-txt"> Version: </span> {{ versions.active }} </span>
          </div>
        </div>

        <button
          class="position-relative d-flex mx-2 mx-1 btn-accello-secondary"
          [disabled]="isDataLoading"
          [matMenuTriggerFor]="recMenu"
          *ngIf="isAgentic"
        >
          <img src='assets/images/virtusa-icons/gn.png' alt="" style="width: 18px;"/>
          <span class="m-auto"> Generate Scripts </span>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>


         <button
          (click)="openSettings()"
          class="btn-accello-secondary  mx-2"
        >
        <img src='assets/images/virtusa-icons/settings-purple.svg'/>
          Settings
        </button>

        <button
          (click)="saveScript()"
          class="btn-accello-secondary  mx-2 menu-save"
          [disabled]="isDataLoading"
        >
        <img src='assets/images/virtusa-icons/save-purple.svg'/>
          Save
        </button>

        <span
          *ngIf="displayVersionList"
          [matTooltip]="'Update the settings before running the test case.'"
          [matTooltipDisabled]="!!selectedAgent"
          matTooltipPosition="below"
          matTooltipClass="run-btn-tooltip"
        >
          <button
            class="btn-accello-primary-light mx-2"
            type="button"
            aria-expanded="false"
            [disabled]="!selectedAgent"
            (click)="runAgent()"
          >
            <img src='assets/images/virtusa-icons/run.svg'/>
            Run
          </button>
        </span>
      </div>
    </div>
    <div class="header-5 d-flex justify-content-end position-relative">
      <div class="actions-wrapper-2 d-flex">
         <div
          class="v-center accello-icon-btn p-1 px-2"
          title="Delete"
          (click)="handleIconActions('delete')"
          (keydown)="handleIconActions('delete')"
          [ngClass]="{ disabled: !selectedRows.length }"
        >
          <img src="assets/images/virtusa-icons/delete-red.svg" alt="trash" />
        </div>
        <div
          class="v-center accello-icon-btn  p-1 px-2"
          title="Paste"
          (click)="handleIconActions('paste')"
          (keydown)="handleIconActions('paste')"
          [ngClass]="{ disabled: !copiedItems?.length }"
        >
          <img src="assets/images/virtusa-icons/paste-purple.svg" alt="paste" />
        </div>
        <div
          class="v-center accello-icon-btn  p-1 px-2"
          title="Copy"
          (click)="handleIconActions('copy')"
          (keydown)="handleIconActions('copy')"
          [ngClass]="{ disabled: !selectedRows.length }"
        >
          <img src="assets/images/virtusa-icons/copy-purple.svg" alt="copy" />
        </div>
       
        <div
          class="v-center accello-icon-btn  p-1 px-2"
          title="Undo"
          (click)="handleIconActions('undo')"
          (keydown)="handleIconActions('undo')"
          [ngClass]="{ disabled: !stackMap['past'].length }"
        >
          <img src="assets/images/virtusa-icons/undo-purple.svg" alt="undo" />
        </div>
        <div
          class="v-center accello-icon-btn p-1 px-2"
          title="Redo"
          (click)="handleIconActions('redo')"
          (keydown)="handleIconActions('redo')"
          [ngClass]="{ disabled: stackMap['current'].length <= 1 }"
        >
          <img src="assets/images/virtusa-icons/redo-purple.svg" alt="redo" />
        </div>
      </div>
      <div class="wrapper-border-div"></div>
    </div>
    <div
      class="zorro-wrap"
      cdkDropList
      id="list-2"
      cdkDropListConnectedTo="tree-node-drag"
      (cdkDropListDropped)="drop($event)"
      (cdkDropListExited)="dropzoneHovered = false; dropzoneActive = false"
      (cdkDropListEntered)="dropzoneHovered = true"
      [ngClass]="{ 'drag-active': dropzoneActive || dropzoneHovered }"
    >
      <div>
        <nz-table
          #expandTable
          [nzData]="steps"
          nzShowPagination="false"
          nzTableLayout="fixed"
          [nzBordered]="false"
          cdkDropList
          id="list-1"
          cdkDropListConnectedTo="tree-node-drag"
          (cdkDropListDropped)="drop($event)"
          (cdkDropListExited)="dropzoneHovered = false; dropzoneActive = false"
          (cdkDropListEntered)="dropzoneHovered = true"
        >
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col" class="text-center line-h-0">
                <input
                  type="checkbox"
                  [checked]="isAllChecked"
                  [indeterminate]="isIndeterminate"
                  (change)="onSelectAll($event)"
                />
              </th>
              <th scope="col" style="width: 90%" class="accello-general-text4">Select all</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody cdkDropList (cdkDropListDropped)="tablePositionChange($event)">
            @for (data of steps; track data) { @for (item of
            mapOfExpandedData[data.row_id]; track item) { @if ((item.parent &&
            item.parent.expand) || !item.parent) {

            <tr
              cdkDrag
              [cdkDragData]="{ item, level: item.level }"
              cdkDragLockAxis="y"
              (mouseenter)="onRowHover(item, data.row_id)"
              (mouseleave)="onMouseLeave(item, data.row_id)"
            >
              <td>
                <span cdkDragHandle class="material-symbols-outlined movable">
                  drag_indicator
                </span>
              </td>
              <td class="text-center">
                {{ item.order }}
              </td>
              <td class="text-center">
                <input
                  type="checkbox"
                  [(ngModel)]="item.rowSelect"
                  (ngModelChange)="onRowSelectChange($event, item)"
                  [ngClass]="{ 'disable-checkbox': item.disableRowSelect }"
                />
              </td>
              <td
                draggable="false"
                [nzShowExpand]="false"
                [(nzExpand)]="item.expand"
                (nzExpandChange)="
                  collapse(mapOfExpandedData[data.row_id], item, $event)
                "
                [nzIndentSize]="item.level! * 14"
              >
                <div class="d-flex">
                  @if(item.children) { @if(item.expand) {
                  <span
                    cdkDragHandle
                    class="material-symbols-outlined cursor-pointer"
                    (click)="collapse(mapOfExpandedData[data.row_id], item, false)"
                    (keydown)="collapse(mapOfExpandedData[data.row_id], item, false)"
                  >
                    keyboard_arrow_down
                  </span>
                  } @else {
                  <span
                    cdkDragHandle
                    class="material-symbols-outlined cursor-pointer"
                    (click)="collapse(mapOfExpandedData[data.row_id], item, true)"
                    (keydown)="collapse(mapOfExpandedData[data.row_id], item, true)"
                  >
                    chevron_right
                  </span>
                  } }
                  <span class="v-center" [ngClass]="{ 'mx-2': !item.children }">
                    {{ item.placeholder }}
                  </span>
                </div>
              </td>

              <td>
                <img
                  *ngIf="item.hovered"
                  (click)="onEditIconClick(item)"
                  src="assets/images/virtusa-icons/edit.svg"
                  alt="edit"
                  class="row-viewer"
                  (keydown.enter)="onEditIconClick(item)"
                />
              </td>
            </tr>
            } } }
          </tbody>
        </nz-table>
      </div>
    </div>
    <div class="drag-info d-flex p-2 px-3">
      <div class="v-center">
        <span class="material-symbols-outlined info-icon"> info </span>
      </div>
      <div class="v-center text-cont">
        Drag and drop commands from the command library to the workspace above,
        to create/modify your test script.
      </div>
    </div>
  </div>

  <div *ngIf="isDataLoading" class="h-100 loading-wrap loader-coal">
    <app-loading
      [text]="loaderText || 'Initializing script editor...'"
    ></app-loading>
  </div>
</div>

<mat-menu #recMenu="matMenu" class="editor-menu-panel">
  <button mat-menu-item (click)="openWebRecorder()">
    <span class="accello-general-text2"> User Flow Capture </span>
  </button>
  <button mat-menu-item [matMenuTriggerFor]="aiMenu">
    <span class="accello-general-text2">Capture</span>
  </button>
</mat-menu>

<mat-menu #aiMenu="matMenu" class="editor-menu-panel">

  <span
    class="w-100"
    [matTooltip]= "tooltipText"
    [matTooltipDisabled]="isMapped"
    matTooltipPosition="right"
  >
    <button mat-menu-item (click)="openApiAutomation()" [disabled]="!isMapped || !isApiAutomationEnabled">
      <span class="accello-general-text2"> API Automation </span>
    </button>
  </span>


  <span
    class="w-100"
    [matTooltip]="tooltipTextAiRecorder"
    [matTooltipDisabled]="isMapped && isLLMConfigured"
    matTooltipPosition="right"
  >
    <button mat-menu-item (click)="openAIRecorder()" [disabled]="!isMapped || !isAiRecorderEnabled">
      <span class="accello-general-text2"> Web Automation </span>
    </button>
  </span>
  <button mat-menu-item (click)="openMobileAutomation()">
    <span class="accello-general-text2"> Mobile Automation </span>
  </button>
</mat-menu>

<mat-menu #versionMenu="matMenu" class="editor-menu-panel">
  <button
    mat-menu-item
    *ngFor="let opt of versions.list"
    (click)="onVersionChange(opt.version)"
  >
    <span class="version-label">{{ opt.version }}</span>
    <span class="labels-wrap" *ngIf="opt.labels?.length > 0">
      <span *ngFor="let label of opt.labels" class="label-chip">{{
        label.name
      }}</span>
    </span>
  </button>
</mat-menu>
